import React, { useEffect, useState } from 'react'
import { swalErrorAlert } from '../../../utils/swal/swal'
import { Link } from 'react-router-dom'

import SchoolRecordPermissionButtonGroup from './SchoolRecordPermissionButtonGroup'
import TablePagination from '../../common/TablePagination'
import { adminGetUserListForSchoolRecordApi } from '../../../api/admin/schoolRecord'

const SchoolRecordUserList = ({ searchTerm }) => {
    /* States */
    const [userList, setUserList] = useState([]) // 학생 리스트

    /* UseEffect */
    useEffect(() => {
        getUserList(searchTerm)
    }, [searchTerm])

    /* Methods */
    const getUserList = async (searchTerm) => {
        try {
            const response = await adminGetUserListForSchoolRecordApi(searchTerm)

            if (response.data.code === 200) {
                const userList = response.data.resData
                setUserList(userList)
            }
        } catch (error) {

            swalErrorAlert()
            setUserList([])
        }
    }

    /* Pagination */
    const itemsPerPage = 10
    const [itemOffset, setItemOffset] = useState(0);
    const endOffset = itemOffset + itemsPerPage;
    const currentItems = userList.slice(itemOffset, endOffset);
    const pageCount = Math.ceil(userList.length / itemsPerPage);
    const handlePageClick = (event) => {
        const newOffset = (event.selected * itemsPerPage) % userList.length;
        setItemOffset(newOffset);
    };


    return (
        <table className='table table-bordered align-middle' style={{ width: "auto", tableLayout: "fixed" }}>
            <colgroup>
                <col width={"200px"} />
                <col width={"400px"} />
                <col width={"200px"} />
                <col width={"320px"} />
            </colgroup>
            <thead>
                <tr className='table-secondary text-center'>
                    <th>이름</th>
                    <th>이메일</th>
                    <th>생활기록부</th>
                    <th>열람권한설정</th>
                </tr>

            </thead>
            <tbody>
                {currentItems &&
                    currentItems.map((user) =>
                        <UserListItem key={'userlist-' + user.user_id} userProp={user} />
                    )
                }
            </tbody>
            <tfoot>
                <tr>
                    <td colSpan={4}>
                        <div className='text-center'>
                            <TablePagination handlePageClick={handlePageClick} pageCount={pageCount} />
                        </div>
                    </td>
                </tr>
            </tfoot>

        </table>
    )
}


const UserListItem = ({ userProp }) => {
    const user = userProp ? userProp : null

    return (
        <tr>
            <td>{user.user_name}</td>
            <td>{user.email}</td>
            <td className='text-center'>
                <Link to={`/hy-admin/school-record/list/${user.user_id}`} className='btn btn-outline-secondary btn-sm'>생활기록부 보기</Link>
            </td>
            <td className='text-center'>
                <SchoolRecordPermissionButtonGroup userId={user.user_id} canView={user?.can_view ?? null} />
            </td>
        </tr>
    )
}

export default SchoolRecordUserList